import React, { useEffect, useState } from "react";
import "./styles.css";
import { useSelector, useDispatch } from "react-redux";
//internal and external components import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableRow, Tooltip, Typography } from "@mui/material/";
import { EnhancedTableHead } from "../EnhancedTableHead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faLock,
  faUnlock,
} from "@fortawesome/free-solid-svg-icons";
import { Box } from "@mui/material";
import CommentsDocsActionsIconWrapper from "../CommentsDocsActionsIconWrapper";
import SelectBoxPrimary from "../SelectBoxPrimary";
import { colors } from "../../common/pallette/colors";
import {
  getLicenceCriteria,
  getLicenceCriteriaStandards,
  getLicenceSaCriteria,
  getLicenceSaCriteriaStandards,
  getLicenceStandardsMetadata,
  restrictCriteriaUsersLicence,
  restrictStandardUsersLicence,
} from "../../api/licence";
import {
  resetSelectedLicenceStandard,
  setLicenceCriteria,
  setLicenceCriteriaStandards,
  setSelectedLicenceStandard,
} from "../../redux/reducers/licence";
import TableSkeleton from "../TableSkeleton";
import {
  genUID,
  licenceSelectedStandardsActionsRegex,
  licenceSelectedStandardsRegex,
  licenceStandardsRegex,
} from "../../common/StaticExports";
import LicenceStandardsDetail from "../../containers/LicenceStandardsDetail";
import { setSnackBarData } from "../../redux/reducers/common";
import { useTranslation } from "react-i18next";
import AccessManager from "../../containers/AccessManager";
import { getAccessCount } from "../../common/logics";
import { useLocation, useNavigate } from "react-router";
import { sortData } from "../../common/SortSupport";

const LicenceStandardsTable = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  // const licenceCriteria = useSelector((state: any) => state.licenceCriteria);
  const currentClub = useSelector((state: any) => state.clubDetails);
  const selectedLicenceCriteria = useSelector(
    (state: any) => state.licence.selectedLicenceCriteria
  );
  const licenceStandards = useSelector(
    (state: any) => state.licence.licenceCriteriaStandards
  );
  const [standards, setStandards] = useState(licenceStandards);
  const selectedLicenceStandard = useSelector(
    (state: any) => state.licence.selectedLicenceStandard
  );
  const isAdmin = useSelector((state: any) => state.common.isAdmin);
  const [isLoading, setIsLoading] = useState(false);
  const initialAccessState = {
    isOpen: false,
    itemId: null,
  };
  const [manageAccess, setManageAccess] = React.useState(initialAccessState);
  const userId = useSelector((state: any) => state.common.user)?.id;

  //supporting contents
  const [order, setOrder] = React.useState("");
  const [orderBy, setOrderBy] = React.useState("");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const visibleRows: any = React.useMemo(
    () => standards?.length > 0 && sortData(standards, orderBy, order),
    [order, orderBy, standards]
  );

  const head = isAdmin
    ? [
        {
          key: "uid",
          displayName: "id",
        },
        {
          key: "name",
          displayName: "licence standards",
        },
        {
          key: "",
          displayName: "",
        },
        {
          key: "isComplete",
          displayName: "club status",
        },
        {
          key: "status",
          displayName: "evaluation rating",
        },
      ]
    : [
        {
          key: "uid",
          displayName: "id",
        },
        {
          key: "name",
          displayName: "licence standards",
        },
        {
          key: "",
          displayName: "",
        },
        {
          key: "progress",
          displayName: "club status",
        },
        {
          key: "",
          displayName: "",
        },
      ];

  const fetchLicenceCriteria = async () => {
    try {
      const response = isAdmin
        ? await getLicenceCriteria({ clubId: currentClub.id })
        : await getLicenceSaCriteria({ clubId: currentClub.id });
      dispatch(setLicenceCriteria(response));
    } catch {}
  };

  const fetchLicenceCriteriaStandards = async () => {
    try {
      const response = isAdmin
        ? await getLicenceCriteriaStandards({
            clubId: currentClub.id,
            criteriaId: selectedLicenceCriteria.id,
          })
        : await getLicenceSaCriteriaStandards({
            clubId: currentClub.id,
            criteriaId: selectedLicenceCriteria.id,
          });
      dispatch(setLicenceCriteriaStandards(response));
      setStandards(response);

      (licenceSelectedStandardsRegex.test(location.pathname) ||
      licenceSelectedStandardsActionsRegex.test(location.pathname)) &&
      manageSelectedStandard(response);
      return 1;
    } catch {
      return 0;
    }
  };

  const manageSelectedStandard = (licenceStandardsResponse: any) => {
    if (
      !selectedLicenceStandard &&
      (licenceSelectedStandardsRegex.test(location.pathname) ||
      licenceSelectedStandardsActionsRegex.test(location.pathname))
    ) {
      var tempStandardId = location.pathname.split("/")[5];
      var tempSelectedStandard = licenceStandardsResponse?.find(
        (d: any) => d.id == tempStandardId
      );
      dispatch(setSelectedLicenceStandard(tempSelectedStandard));

      // licenceSelectedStandardsRegex.test(location.pathname) &&
      // fetchStandardsData(tempSelectedStandard);

      
    // navigate(`/licence/criteria/${selectedLicenceCriteria?.id}/standards/${detail?.id}`);
    }
  };

  React.useEffect(() => {
    if (
      currentClub &&
      selectedLicenceCriteria?.id &&
      (licenceStandardsRegex.test(location.pathname) ||
      licenceSelectedStandardsRegex.test(location.pathname) ||
      licenceSelectedStandardsActionsRegex.test(location.pathname)) &&
      !licenceStandards
    ) {
      setIsLoading(true);
      fetchLicenceCriteriaStandards().then(() => {
        setIsLoading(false);
      });
    }

    licenceStandards &&
    manageSelectedStandard(licenceStandards);
  }, [selectedLicenceCriteria, currentClub, location, licenceStandards]);

  const fetchStandardsData = async (detail: any) => {
    const response = await getLicenceStandardsMetadata({
      standardsId: detail.id,
    });
    dispatch(setSelectedLicenceStandard(response));
    navigate(`/licence/criteria/${selectedLicenceCriteria?.id}/standards/${detail?.id}`);
  };

  const triggerStandardsUpdate = (restrictedUsers:any) => {
      var updatedStandard = standards?.find(
        (x: any) => x.id == manageAccess?.itemId
      );
      updatedStandard = {
        ...updatedStandard,
        restrictions: updatedStandard?.restrictions?.map((res: any) => {
          if (restrictedUsers?.includes(res.userId)) {
            return { ...res, isRestricted: true };
          }
          return res;
        }),
      };
      setStandards(
        standards?.map((c: any) =>
          c.id == updatedStandard.id ? updatedStandard : c
        )
      );
      restrictStandardUsersLicence({
        clubId: currentClub?.id,
        standardId: manageAccess?.itemId,
        users: restrictedUsers,
      })
        .then(() => {
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACCESS_UPDATED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
          fetchLicenceCriteriaStandards();
        })
        .catch((error: any) => {
          const warningData: any = {
            isOpen: true,
            severity: "error",
            message: error?.message || t("ACCESS_UPDATE_FAILED"),
          };
          dispatch(setSnackBarData(warningData));
          setStandards(licenceStandards);
        });
  }

  const manageUserAccess = (isUpdated: any, restrictedUsers: any, newUnRestrictedUsers?: any, unResestrictedUsersForAllStandards?: any) => {
    if (isUpdated) {
        if (newUnRestrictedUsers !== null && newUnRestrictedUsers !== undefined && newUnRestrictedUsers.length > 0) {
          var criteriaRestrictedUserIds = selectedLicenceCriteria?.restrictions?.filter((res:any) => res.isRestricted)?.map((x:any) => x.userId) || [];
          var updatedCriteriaRestrictedUsers = newUnRestrictedUsers ? criteriaRestrictedUserIds?.filter((num:any) => !newUnRestrictedUsers?.includes(num)) : [];
          restrictCriteriaUsersLicence({clubId: currentClub?.id, criteriaId: selectedLicenceCriteria?.id, users: updatedCriteriaRestrictedUsers})
          .then(() => {
            //updating standards table after criteria restriction update
            var updatedStandard = standards?.find((x:any) => x.id == manageAccess?.itemId);
            updatedStandard = {...updatedStandard, restrictions: updatedStandard?.restrictions?.map((res:any) => {
              if(restrictedUsers?.includes(res.userId)) {
                return {...res, isRestricted: true}
              } return res;
            })};
            //manage other standards restrictions as it is / as required
            var otherStandards = standards?.filter((c:any) => c.id !== updatedStandard.id);
            otherStandards?.map((os:any) => {
              var tempUpdatedRestrictedUsers = os?.restrictions?.filter((res:any) => res.isRestricted)?.map((x:any) => x.userId) || [];
              tempUpdatedRestrictedUsers = [...tempUpdatedRestrictedUsers, ...newUnRestrictedUsers];
              if(unResestrictedUsersForAllStandards && unResestrictedUsersForAllStandards.length > 0) {
                tempUpdatedRestrictedUsers = tempUpdatedRestrictedUsers?.filter((num:any) => !unResestrictedUsersForAllStandards?.includes(num));
              }
              restrictStandardUsersLicence({clubId: currentClub?.id, standardId: os?.id, users: tempUpdatedRestrictedUsers});
            });
            //manage current standard restriction update in the table
            setStandards(standards?.map((c:any) => c.id == updatedStandard.id ? updatedStandard : c));
            triggerStandardsUpdate(restrictedUsers);
            fetchLicenceCriteria();
          })
          .catch((error:any) => {
            const warningData: any = {
              isOpen: true,
              severity: "error",
              message: error?.message || t("ACCESS_UPDATE_FAILED"),
            };
            dispatch(setSnackBarData(warningData));
          });
        } else {
          triggerStandardsUpdate(restrictedUsers);
        }
    }
    setManageAccess(initialAccessState);
  };

  //table contents
  return (
    <React.Fragment>
      <Box sx={{ position: "relative" }}>
        <LicenceStandardsDetail
          isOpen={
            selectedLicenceStandard &&
            Object.keys(selectedLicenceStandard)?.length > 0
          }
          detail={selectedLicenceStandard}
          handleClose={() => {
            if (!licenceSelectedStandardsActionsRegex.test(location.pathname)) {
              navigate(`/licence/criteria/${selectedLicenceCriteria?.id}/standards`);
              dispatch(resetSelectedLicenceStandard());
              fetchLicenceCriteriaStandards();
              fetchLicenceCriteria();
            }
          }}
        />
        <AccessManager
          isOpen={manageAccess?.isOpen}
          handleIsOpen={manageUserAccess}
          from={"licenceStandards"}
          itemId={manageAccess?.itemId}
          criteriaRestrictions={selectedLicenceCriteria?.restrictions}
        />
        <TableContainer sx={{ height: "auto", overflowY: "auto" }}>
          <Table stickyHeader size="small" aria-label="a dense table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              tableHeads={head}
            />
            <TableBody>
              {visibleRows && visibleRows?.length ? (
                visibleRows.map((d: any, i: number) => {
                  const totalUsers = d?.restrictions?.length || 0;
                  const accessCount = getAccessCount(d?.restrictions);
                  const isPrivate = totalUsers == accessCount ? false : true;
                  const restrictedUsers =
                    d?.restrictions
                      ?.filter((res: any) => res.isRestricted)
                      ?.map((x: any) => x.userId) || [];
                  const isRestricted = restrictedUsers?.includes(userId);
                  return (
                    <TableRow
                      className={
                        isRestricted
                          ? "selectedRow cursorNotAllowed"
                          : "hoverBG"
                      }
                      sx={{ cursor: "pointer" }}
                      key={`standards-table-row-${i}`}
                    >
                      <TableCell className="fs12">{genUID(d.uid)}</TableCell>
                      <TableCell
                        className="fs12"
                        sx={{
                          cursor: isRestricted ? "not-allowed" : "pointer",
                          width: isAdmin ? "50%" : "60%",
                        }}
                        onClick={() => {
                          !isRestricted && fetchStandardsData(d);
                        }}
                      >
                        {d.name}
                      </TableCell>
                      <TableCell className="fs12" sx={{ minWidth: '180px' }}>
                        <CommentsDocsActionsIconWrapper
                          actions={d.noOfActions || 0}
                          comments={d.noOfComments || 0}
                          docs={d.noOfEvidences || 0}
                        />
                      </TableCell>
                      <TableCell className="fs12">
                        {isAdmin ? (
                          <>
                            {d?.isComplete ? "Complete" : "Not Complete"}
                            {d?.isComplete && (
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                className="ml10"
                                color={colors.green.bright}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            {d?.progress == 100 ? "Complete" : "Not Complete"}
                            {d?.progress == 100 && (
                              <FontAwesomeIcon
                                icon={faCircleCheck}
                                className="ml10"
                                color={colors.green.bright}
                              />
                            )}
                          </>
                        )}
                      </TableCell>
                      {isAdmin && (
                        <TableCell className="fs12">
                          <SelectBoxPrimary
                            label={""}
                            options={[0, 1, 3]}
                            isStatus={true}
                            selected={d.status || 0}
                            report={"siteReview"}
                          />
                        </TableCell>
                      )}
                      {!isAdmin && (
                        <TableCell sx={{ minWidth: '40px' }}>
                          <Tooltip
                            title={!isRestricted && t("TDM_MANAGE_ACCESS")}
                            arrow
                            placement="top"
                            className={isPrivate ? "closedLock" : ""}
                          >
                            <span>
                              <Typography className="fs12 lockCountLabel mr5">
                                {isPrivate ? accessCount : ""}
                              </Typography>
                              <FontAwesomeIcon
                                className={
                                  isPrivate ? "icon closedLock" : "icon"
                                }
                                icon={isPrivate ? faLock : faUnlock}
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  !isRestricted &&
                                    setManageAccess({
                                      isOpen: true,
                                      itemId: d.id,
                                    });
                                }}
                              />
                            </span>
                          </Tooltip>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })
              ) : !visibleRows && !isLoading ? (
                <TableRow>
                  <TableCell
                    colSpan={head?.length}
                    sx={{ textAlign: "center" }}
                  >
                    {t("NO_RECORDS_FOUND")}
                  </TableCell>
                </TableRow>
              ) : (
                isLoading && (
                  <TableSkeleton rowCount={6} cellCount={head?.length} />
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </React.Fragment>
  );
};

export default LicenceStandardsTable;
